
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.863 18a1 1 0 01-.729-.315l-4.863-5.18a1 1 0 111.457-1.368l4.125 4.39 8.408-9.201a1 1 0 011.477 1.348l-9.137 10a.998.998 0 01-.73.326h-.008z","fill":"#40AE49"}})])
          )
        }
      }
    